import { Route, Redirect, RouteProps, useLocation } from 'react-router-dom';

export interface AuthenticatedRouteProps extends RouteProps {
    component: React.ComponentType<any>;
    user: any;
}

export const AuthenticatedRoute = ({
    component: Component,
    user,
    ...rest
}: AuthenticatedRouteProps) => {
    const location = useLocation();
    return (
        <Route
            {...rest}
            render={(props) =>
                user ? (
                    <Component {...props} user={user} />
                ) : (
                    <Redirect to={{ pathname: '/login', state: { referrer: location } }} />
                )
            }
        />
    );
};
